import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Globe } from "lucide-react";

const Ctx = createContext(null);

const initialLang = () => {
  const q = new URLSearchParams(window.location.search).get("lang");
  if (q === "es" || q === "en") return q;
  return localStorage.getItem("cora_lang") || "en";
};

export const LangProvider = ({ children }) => {
  const [lang, setLangState] = useState(initialLang);

  useEffect(() => {
    document.documentElement.lang = lang;
    localStorage.setItem("cora_lang", lang);
  }, [lang]);

  const setLang = useCallback((l) => {
    setLangState(l);
    const u = new URL(window.location.href);
    if (l === "es") u.searchParams.set("lang", "es");
    else u.searchParams.delete("lang");
    window.history.replaceState(window.history.state, "", u);
  }, []);

  const value = useMemo(() => ({
    lang,
    setLang,
    tr: (en, es) => (lang === "es" ? es : en),
    pick: (o, k) => (lang === "es" && o[`${k}_es`]) || o[k],
  }), [lang, setLang]);

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useLang = () => useContext(Ctx);

export const LangToggle = () => {
  const { lang, setLang } = useLang();
  return (
    <div className="flex items-center gap-1 rounded-full border border-[#00C9B7]/40 bg-black/30 p-0.5 pl-2 text-[11px] font-bold" data-testid="lang-toggle">
      <Globe size={13} className="text-[#00C9B7]" />
      {["en", "es"].map((l) => (
        <button key={l} onClick={() => setLang(l)} className={`px-2.5 py-1 rounded-full uppercase transition-colors ${lang === l ? "bg-[#00C9B7] text-[#031312]" : "text-slate-300 hover:text-white"}`} data-testid={`lang-${l}-btn`}>{l}</button>
      ))}
    </div>
  );
};
